import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import api from '../api';

const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
const now = new Date();

export default function Attendance() {
  const [staff, setStaff] = useState([]);
  const [records, setRecords] = useState([]);
  const [filterMonth, setFilterMonth] = useState(now.getMonth() + 1);
  const [filterYear, setFilterYear] = useState(now.getFullYear());
  const [selectedDate, setSelectedDate] = useState(now.toISOString().split('T')[0]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  const load = async () => {
    const [staffRes, attRes] = await Promise.all([
      api.get('/staff'),
      api.get('/staff/attendance', { params: { month: filterMonth, year: filterYear } })
    ]);
    setStaff(staffRes.data);
    setRecords(attRes.data);
    setLoading(false);
  };

  useEffect(() => { load(); }, [filterMonth, filterYear]);

  const getStatus = (staffId, date) => {
    const r = records.find(r => r.staff?._id === staffId && r.date?.split('T')[0] === date);
    return r?.status || null;
  };

  const markAttendance = async (staffId, status) => {
    try {
      await api.post('/staff/attendance', { staff: staffId, date: selectedDate, status });
      setMsg(`Marked ${status}`);
      load();
    } catch (err) { setMsg('Error marking attendance'); }
  };

  return (
    <Layout title="Staff Attendance">
      {msg && <div className="alert alert-info">{msg} <button style={{ float:'right', background:'none', border:'none', cursor:'pointer' }} onClick={() => setMsg('')}>✕</button></div>}

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">📋 Mark Attendance</h3>
        </div>
        <div className="filters-bar">
          <div className="form-group" style={{ margin: 0 }}>
            <label>Date</label>
            <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} />
          </div>
        </div>

        {loading ? <div className="text-center" style={{ padding: 40 }}>Loading...</div> : (
          <div className="table-wrapper">
            <table>
              <thead>
                <tr><th>Staff Name</th><th>Role</th><th>Status on {selectedDate}</th><th>Mark Attendance</th></tr>
              </thead>
              <tbody>
                {staff.filter(s => s.status === 'Active').length === 0 ? (
                  <tr><td colSpan={4} className="text-center" style={{ padding: 30, color: '#718096' }}>No active staff. Add staff first.</td></tr>
                ) : staff.filter(s => s.status === 'Active').map(s => {
                  const status = getStatus(s._id, selectedDate);
                  return (
                    <tr key={s._id}>
                      <td><strong>{s.name}</strong></td>
                      <td><span className={`badge ${s.role === 'Security Guard' ? 'badge-warning' : 'badge-info'}`}>{s.role}</span></td>
                      <td>
                        {status ? (
                          <span className={`badge ${status === 'Present' ? 'badge-success' : status === 'Absent' ? 'badge-danger' : 'badge-warning'}`}>
                            {status}
                          </span>
                        ) : <span className="text-muted">Not Marked</span>}
                      </td>
                      <td>
                        <div className="flex gap-10">
                          <button className="btn btn-success btn-sm" onClick={() => markAttendance(s._id, 'Present')}>✅ Present</button>
                          <button className="btn btn-danger btn-sm" onClick={() => markAttendance(s._id, 'Absent')}>❌ Absent</button>
                          <button className="btn btn-warning btn-sm" onClick={() => markAttendance(s._id, 'Leave')}>🏖 Leave</button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Monthly Summary */}
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">📊 Monthly Attendance Summary</h3>
          <div className="flex gap-10">
            <select value={filterMonth} onChange={e => setFilterMonth(e.target.value)}>
              {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
            </select>
            <select value={filterYear} onChange={e => setFilterYear(e.target.value)}>
              {[2024, 2025, 2026, 2027].map(y => <option key={y}>{y}</option>)}
            </select>
          </div>
        </div>

        {staff.map(s => {
          const staffRecords = records.filter(r => r.staff?._id === s._id);
          const present = staffRecords.filter(r => r.status === 'Present').length;
          const absent = staffRecords.filter(r => r.status === 'Absent').length;
          const leave = staffRecords.filter(r => r.status === 'Leave').length;
          return (
            <div key={s._id} style={{ padding: '12px 0', borderBottom: '1px solid #f0f4f8', display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <strong style={{ fontSize: 14 }}>{s.name}</strong>
                <span style={{ fontSize: 12, color: '#718096', marginLeft: 8 }}>{s.role}</span>
              </div>
              <div className="flex gap-10">
                <span className="badge badge-success">✅ {present} Present</span>
                <span className="badge badge-danger">❌ {absent} Absent</span>
                <span className="badge badge-warning">🏖 {leave} Leave</span>
              </div>
            </div>
          );
        })}
      </div>
    </Layout>
  );
}
